import helpers from './helpers'
import authService from './service'
export default {
  initialise ({state, commit, rootState, dispatch}, data) {
    return new Promise((resolve, reject) => {
      let token = helpers.getTokenFromLocalStorage()
      let user = helpers.getUserFromLocalStorage()
      if (!token || !user) {
        helpers.refreshAuth(commit, { user: null, token: null })
        reject({ auth: false })
      } else {
        helpers.refreshAuth(commit, { user, token })
        resolve({auth: true})
      }
    })
  },
  refreshToken ({commit, state}, token) {
    return new Promise((resolve, reject) => {
      if (!helpers.currentTokenValid(state.expiresIn, state.expiresFrom) && !state.hasCurrentActiveRequest) {
        commit('UPDATE_ACTIVE_REQUEST_TOGGLE', true)
        commit('UPDATE_TIMINGS')
        authService.refreshToken().then(({data}) => {
          helpers.setTokenInLocalStorage(data.token)
          helpers.setUserInLocalStorage(data.details)
          helpers.refreshAuth(commit, { user: data.details, token: data.token })
          commit('UPDATE_ACTIVE_REQUEST_TOGGLE', false)
          resolve()
        }).catch(err => {
          console.log(err)
          commit('UPDATE_ACTIVE_REQUEST_TOGGLE', false)
          reject(false)
        })
      } else {
        resolve()
      }
    })
  },
  invalidate ({state, commit, rootState}, data) {
    return new Promise((resolve, reject) => {
      helpers.removeTokenFromLocalStorage()
      helpers.removeUserFromLocalStorage()
      commit('SET_TOKEN', null)
      commit('RESET_USER')
      resolve()
    })
  },
  checkAuth ({state, commit, rootState}, data) {
    return new Promise((resolve, reject) => {
      authService.checkAuth()
        .then(({data}) => {
          if (data.authenticated) {
            resolve(true)
          } else {
            reject(false)
          }
        })
        .catch((err) => {
          console.log(err)
          reject(false)
        })
    })
  },
  login ({state, commit, rootState}, d) {
    return new Promise((resolve, reject) => {
      authService.login(d)
        .then(({data}) => {
          helpers.setTokenInLocalStorage(data.token)
          helpers.setUserInLocalStorage(data.details)
          helpers.refreshAuth(commit, { user: data.details, token: data.token })
          resolve(data.access_token)
        })
        .catch(err => {
          console.log(err)
          reject(err)
        })
    })
  },
  healthCheck ({state, commit, rootState}, d) {
    return new Promise((resolve, reject) => {
      authService.healthCheck(d)
        .then(({data}) => {
          resolve(data)
        })
        .catch(err => {
          console.log(err)
          reject(err)
        })
    })
  },
  healthCheckOpti ({state, commit, rootState}, d) {
    return new Promise((resolve, reject) => {
      authService.healthCheckOpti(d)
        .then(({data}) => {
          resolve(data)
        })
        .catch(err => {
          console.log(err)
          reject(err)
        })
    })
  },
  fakeLogin ({state, commit, rootState}, data) {
    helpers.setTokenInLocalStorage('I-AM-A-FAKE-JWT-TOKEN')
    commit('SET_TOKEN', 'I-AM-A-FAKE-JWT-TOKEN')
    return Promise.resolve('logged-in')
  }
}



// WEBPACK FOOTER //
// ./src/modules/authentication/store/actions.js